import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { ReactComponent as ArrowForwardIosIcon } from "../../assets/icons/nextArrow.svg";
import { ReactComponent as ArrowBackIosIcon } from "../../assets/icons/prevArrow.svg";
import axios from "axios";
import { isMobile, returnImage } from "../../utils/tools";
import { useDispatch, useSelector } from "react-redux";
import { API_URL, GKEY, GPKEY, URL_GOLDEN } from "../../const/api";
import ModalSlots from "../../pages/Slots/ModalSlots";
import { Link, useLocation } from "react-router-dom";
import md5 from "blueimp-md5";
import { Helmet } from "react-helmet";
import { ReactComponent as LoaderSvg } from "../../assets/icons/puff.svg";
import {
  logout,
  selectCurrency,
  selectId,
  selectLogged,
  selectToken,
  selectUser,
  setNewToken,
  setUserBets,
} from "../../features/user/userSlice";
import {
  Span,
  WitgetContainer,
  ContainerMultiItems,
  MultiItemscolumn,
  MultiItemsCard,
  BtnBadge,
  ContentCardImage,
  BtnViewMore,
  ContentTitleBtn,
  SeoH1,
  SeoH2,
} from "./CarouselCasinoElements";
import useMediaQuery from "@mui/material/useMediaQuery";

const ForwardIcon = styled(ArrowForwardIosIcon)`
  border: 1px solid ${PRIMARY};
  padding: 7px;
  transition: all 0.3s ease-in-out 0s;
  width: 50px !important;
  height: 40px !important;
  background: ${SECONDARY};
  path {
    stroke: #fff;
    transition: all 0.3s ease-in-out 0s;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }
  &:hover {
    background: ${SECONDARY};
  }
`;

const BackIcon = styled(ArrowBackIosIcon)`
  border: 1px solid ${PRIMARY};
  padding: 7px;
  transition: all 0.3s ease-in-out 0s;
  width: 50px !important;
  height: 40px !important;
  background: ${SECONDARY};
  path {
    stroke: #fff;
    transition: all 0.3s ease-in-out 0s;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }
  &:hover {
    background: ${SECONDARY};
  }
`;

const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);
const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);
const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  > svg {
    font-size: 32px;
    color: #fff;
  }
`;
const CarouselMultiCasino = () => {
  const [t, i18n] = useTranslation("global");

  const [GoldenNuevos, setGoldenNuevos] = useState(null);
  const [PragmaticNuevos, setPragmaticNuevos] = useState(null);
  const [juegosNuevosCombinados, setJuegosNuevosCombinados] = useState([]);
  const [juegosTopCombinados, setJuegosTopCombinados] = useState([]);
  const [juegosTop, setJuegosTop] = useState([])
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const [casino, setCasino] = useState(null);
  const [openCasino, setOpenCasino] = useState(false);

  const isLoged = useSelector(selectLogged);

  const [cargando, setCargando] = useState(true);

  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    const loadPromociones = async () => {
      try {
        const response = await axios.post(API_URL + "loadPromociones");

        // Filtrar las promociones por el idioma del usuario
        const filteredPromotions = response.data.response.deportes.filter(
          (promo) => promo.lang === i18n.language
        );
        setPromotions(filteredPromotions);
      } catch (error) {
        console.error("Error al cargar promociones:", error);
        setPromotions([
          {
            titulo: "Error",
            detalle:
              "No se pudo cargar la lista de bonos. Por favor, inténtalo de nuevo más tarde.",
            picture:
              "https://masterbets365.com/static/media/logo.291eacffcd58797e638642a6e44ed6b2.svg",
          },
        ]);
      }
    };

    loadPromociones();
  }, [i18n.language]);

  // URL dinámica para imágenes
  const getImageUrl = (picture) => {
    return `https://admin.betsfactory.co/admin/contenido/${i18n.language}/banner_deportes/${picture}`;
  };

  const changeLink = (link) => {
    const currentURL = window.location.href;
    let formattedLink = '';

    // Determina el dominio actual
    const newDomain = currentURL.includes("https://www.masterbets365.com/") ? "https://www.masterbets365.com" :
                   currentURL.includes("https://masterbets365.com/") ? "https://masterbets365.com" :
                   currentURL.includes("https://www.masterbets365.net/") ? "https://www.masterbets365.net" :
                   currentURL.includes("https://masterbets365.net/") ? "https://masterbets365.net" :
                   "";

    console.log("New domain:", newDomain);
    // Formatea el enlace
    if (link.includes("https://masterbets365.com/") || link.includes("https://www.masterbets365.com/")) {
        const cleanLink = link.replace(/https?:\/\/(?:www\.)?masterbets365\.com\//, "");
        formattedLink = cleanLink.startsWith("/") ? cleanLink : `/${cleanLink}`;
    } else if (link.includes("https://masterbets365.net/") || link.includes("https://www.masterbets365.net/")) {
        const cleanLink = link.replace(/https?:\/\/(?:www\.)?masterbets365\.net\//, "");
        formattedLink = cleanLink.startsWith("/") ? cleanLink : `/${cleanLink}`;
    }

    // Limpia la parte del fragmento de la URL después de redirigir
    const redirectToCleanURL = () => {
        const cleanURL = window.location.href.split('#')[0];
        window.history.replaceState(null, null, cleanURL);
    };

    // Redirigir y limpiar la URL
    redirectToCleanURL();

    return newDomain + formattedLink;
  };


  const discountArrayUpdated = promotions.map((promo, index) => ({
    title: promo.titulo,
    imageUrl: getImageUrl(promo.picture),
    link: changeLink(promo.link),
    key: index,
  }));


  const changebanner2 = useMediaQuery("(min-width:480px)");

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: (
      <PrevArrow>
        <BackIcon />
      </PrevArrow>
    ),
    nextArrow: (
      <NextArrow>
        <ForwardIcon />
      </NextArrow>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settingsDeporte = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: (
      <PrevArrow>
        <BackIcon />
      </PrevArrow>
    ),
    nextArrow: (
      <NextArrow>
        <ForwardIcon />
      </NextArrow>
    ),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settingsDeporteMovil = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: (
      <PrevArrow>
        <BackIcon />
      </PrevArrow>
    ),
    nextArrow: (
      <NextArrow>
        <ForwardIcon />
      </NextArrow>
    ),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://platform.betsfactory.co/api/getOrdenSlotsTopNew"
        );

        const topGames = await axios.post(
          API_URL+"getOrdenSlotsTop", {}
        );
   
        if(topGames.data) {
          const {golden_top, pragmatic_top} = topGames.data.response
          //console.log("topGames", topGames.data)
          let allGames = [...pragmatic_top, ...golden_top]
          allGames = allGames.map(x=>({...x, order: parseInt(x.order)}))
          allGames.sort((a,b)=>a.order-b.order)
          //console.log("allGames ordr", allGames)
          setJuegosTop(allGames)
        }
        
        if (response.status === 200) {
          const { data } = response;

          // Verifica si la propiedad response existe
          if (data && data.response) {
            const {
              golden_nuevos,
              pragmatic_nuevos,
              pragmatic_top_especiales,
              golden_top_especiales,
            } = data.response;
            console.log("*****",golden_nuevos)
            // Guardar juegos nuevos de Golden
            if (golden_nuevos) {
              setGoldenNuevos(golden_nuevos);
            } else {
              console.error(
                "La propiedad golden_nuevos no está presente en la respuesta JSON."
              );
            }

            // Guardar juegos nuevos de Pragmatic
            if (pragmatic_nuevos) {
              setPragmaticNuevos(pragmatic_nuevos);
            } else {
              console.error(
                "La propiedad pragmatic_nuevos no está presente en la respuesta JSON."
              );
            }

            // Combinar juegos nuevos de Pragmatic y Golden
            setJuegosNuevosCombinados(pragmatic_nuevos.concat(golden_nuevos));
            //combinar juegos top de pramatic y golden
            setJuegosTopCombinados(
              pragmatic_top_especiales.concat(golden_top_especiales)
            );
          } else {
            console.error(
              "La propiedad response no está presente en la respuesta JSON."
            );
          }
        } else {
          console.error(
            `Error al hacer la solicitud. Código de respuesta: ${response.status}`
          );
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      } finally {
        setCargando(false); // Indica que la carga ha finalizado
      }
    };

    fetchData();
  }, []);

  const openSlotCombinados = async (val, proveedor) => {
    const symbol = val;
    let URLSlot = "";

    if (proveedor === "pragmatic") {
      const language = i18n.language;

      //if(user==='test'||user==='test2'||user==='test3'||user.toLowerCase()==='test4'||user==='testbrasil') {
      if (isLoged) {
        const body = { language, token, symbol };
        const { data } = await axios.post(API_URL + "openGame", body);
        let json = JSON.parse(data);
        if (json.error === "0") URLSlot = json.gameURL;
      } else {
        if (symbol === "vs50pixie") {
          const body = { language, symbol };
          const { data } = await axios.post(API_URL + "openGame", body);
          let json = JSON.parse(data);
          if (json.error === "0") URLSlot = json.gameURL;
        } else {
          const lobbyUrl = "https://masterbets365.com/";
          const secureLogin = "sipn_masterbets365com";
          URLSlot =
            "https://demogamesfree.pragmaticplay.net/gs2c/openGame.do?cur=USD&gameSymbol=" +
            symbol +
            "&lobbyURL=" +
            lobbyUrl +
            "&stylename=" +
            secureLogin +
            "&lang=" +
            language;
        }
      }
      /* } else {
	        const technology = "H5";
	        const platform = "WEB";
	        const cashierUrl = "masterbets365.com";
	        const lobbyUrl = "https://masterbets365.com/";
	        const secureLogin = "sipn_masterbets365com";
	        if (!isLoged) {
	          URLSlot =
	            "https://demogamesfree.pragmaticplay.net/gs2c/openGame.do?cur=USD&gameSymbol=" +
	            symbol +
	            "&lobbyURL=" +
	            lobbyUrl +
	            "&stylename=" +
	            secureLogin+
	            "&lang="+language;
	        } else {
	          const domain = "servi-peruvian-br0.pragmaticplay.net";
	          URLSlot = window.GameLib.gameUrl(
	            domain,
	            token,
	            symbol,
	            technology,
	            platform,
	            language,
	            cashierUrl,
	            lobbyUrl,
	            secureLogin
	          );
	        }
	      } */
    } else {
      if (proveedor === "spinmatic") {
        let url = "https://masterbets365.com";
        let platform = isMobile() ? "mobile" : "desktop";

        if (isLoged) {
          let encoded = md5(
            token + symbol + url + i18n.language + platform + url + GKEY
          );
          URLSlot = `${URL_GOLDEN}?token=${token}&game=${symbol}&backurl=${url}&language=${i18n.language}&clientPlatform=${platform}&cashierurl=${url}&h=${encoded}`;
        } else {
          let encoded = md5(
            "" + symbol + url + "0" + i18n.language + platform + url + GKEY
          );
          URLSlot = `${URL_GOLDEN}?token=&game=${symbol}&backurl=${url}&mode=0&language=${i18n.language}&clientPlatform=${platform}&cashierurl=${url}&h=${encoded}`;
        }
      }
    }

    setCasino(URLSlot);
    setOpenCasino(true);
  };
  const handleClose = () => {
    setCasino(null);
    setOpenCasino(false);
  };

  return (
    <>
      <Helmet>
        {isLoged ? (
          <script src="https://api-br0.pragmaticplay.net/gs2c/common/js/lobby/GameLib.js"></script>
        ) : (
          <script src="https://api.prerelease-env.biz/gs2c/common/js/lobby/GameLib.js"></script>
        )}
      </Helmet>
      {openCasino && casino && (
        <ModalSlots open={openCasino} handleClose={handleClose} url={casino} />
      )}
      {/* carousel de deporte */}
      <WitgetContainer>
        <ContentTitleBtn>
          <span className="title">{t(`home.title-sport`)}</span>
          <BtnViewMore to={t(`header.link-1.url`)}>
            <span className="circle" aria-hidden="true">
              <span className="icon arrow">+</span>
            </span>
            <span className="button-text">{t(`home.see-more`)}</span>
          </BtnViewMore>
        </ContentTitleBtn>
        <SeoH1>{t(`home.textodeportes`)}</SeoH1>
        {changebanner2 ? (
          <Slider {...settingsDeporte}>
            {discountArrayUpdated.map((item) => (
              <MultiItemscolumn key={item.key}>
                <MultiItemsCard
                  className="deportes"
                  style={{
                    backgroundImage: `url("${item.imageUrl}")`,
                  }}
                >
                  <ContentCardImage>
                    <Link to={item.link} className="btnplay">
                      {t("buttons.play-now")}
                    </Link>
                  </ContentCardImage>
                </MultiItemsCard>
                <span className="titlecard">{item.title}</span>
              </MultiItemscolumn>
            ))}
          </Slider>
        ) : (
          <Slider {...settingsDeporteMovil}>
            {discountArrayUpdated.map((item) => (
              <MultiItemscolumn key={item.key}>
                <MultiItemsCard
                  className="deportes"
                  style={{
                    backgroundImage: `url("${item.imageUrl}")`,
                  }}
                >
                  <ContentCardImage>
                    <Link to={item.link} className="btnplay">
                      {t("buttons.play-now")}
                    </Link>
                  </ContentCardImage>
                </MultiItemsCard>
                <span className="titlecard">{item.title}</span>
              </MultiItemscolumn>
            ))}
          </Slider>
        )}
      </WitgetContainer>
      {/* carousel de casino top */}
      <WitgetContainer>
        <ContentTitleBtn>
          <span className="title">{t(`home.title-slot-top`)}</span>
          <BtnViewMore to={t(`header.link-4.url`)}>
            <span className="circle" aria-hidden="true">
              <span className="icon arrow">+</span>
            </span>
            <span className="button-text">{t(`home.see-more`)}</span>
          </BtnViewMore>
        </ContentTitleBtn>
        <SeoH2>{t(`home.textoPrincipalJuegos`)}</SeoH2>
        {cargando ? (
          <Container>
            <LoaderSvg />
          </Container>
        ) : (
          <Slider {...settings}>
            {juegosTop.map((juego, index) => (
              <MultiItemscolumn key={index}>
                <MultiItemsCard>
                  <img src={returnImage(juego.gameName, (juego.gameID ? juego.gameID : juego.thumbnail),juego.gameTitle)} alt={juego.name}></img>
                  <BtnBadge className="fire">
                    TOP <span className="particle1"></span>
                    <span className="particle2"></span>
                  </BtnBadge>
                  <ContentCardImage>
                    <button
                      className="btnplay"
                      onClick={() => {
                        if (juego.gameID) {
                          openSlotCombinados(juego.gameID, "pragmatic");
                        } else {
                          openSlotCombinados(juego.gameId, "spinmatic");
                        }
                      }}
                    >
                      {t("buttons.play-now")}
                    </button>
                  </ContentCardImage>
                </MultiItemsCard>
                <span className="titlecard">
                  {juego.gameName || juego.gameTitle}
                </span>
              </MultiItemscolumn>
            ))}
          </Slider>
        )}
      </WitgetContainer>
      {/* carousel de casino new */}
      <WitgetContainer>
        <ContentTitleBtn>
          <span className="title">{t(`home.title-slot-new`)}</span>
          <BtnViewMore to={t(`header.link-4.url`)}>
            <span className="circle" aria-hidden="true">
              <span className="icon arrow">+</span>
            </span>
            <span className="button-text">{t(`home.see-more`)}</span>
          </BtnViewMore>
        </ContentTitleBtn>
        {cargando ? (
          <Container>
            <LoaderSvg />
          </Container>
        ) : (
          <Slider {...settings}>
            {juegosNuevosCombinados.map((juego, index) => (
              <MultiItemscolumn key={index}>
                <MultiItemsCard>
                  <img src={returnImage(juego.gameName, (juego.gameID ? juego.gameID : juego.thumbnail),juego.gameTitle)} alt={juego.name}></img>
                  <BtnBadge className="new">New</BtnBadge>
                  <ContentCardImage>
                    <button
                      className="btnplay"
                      onClick={() => {
                        if (juego.gameID) {
                          openSlotCombinados(juego.gameID, "pragmatic");
                        } else {
                          openSlotCombinados(juego.gameId, "spinmatic");
                        }
                      }}
                    >
                      {t("buttons.play-now")}
                    </button>
                  </ContentCardImage>
                </MultiItemsCard>
                <span className="titlecard">
                  {juego.gameName || juego.gameTitle}
                </span>
              </MultiItemscolumn>
            ))}
          </Slider>
        )}
      </WitgetContainer>
    </>
  );
};

export default CarouselMultiCasino;
